import { Injectable, inject } from '@angular/core';
import { CoreActions } from '@next/core-lib';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, finalize, map, mergeMap, startWith } from 'rxjs/operators';

import { SalesPotentialApiService } from '../../shared/services/sales-potential-api.service';
import {
  DeleteSalesPotentialFailed,
  DeleteSalesPotentialRequest,
  DeleteSalesPotentialSuccess,
  LoadSalesPotentialsFailed,
  LoadSalesPotentialsRequest,
  LoadSalesPotentialsSuccess,
  SalesPotentialActionTypes,
  UpsertSalesPotentialFailed,
  UpsertSalesPotentialRequestAction,
  UpsertSalesPotentialSuccess,
} from '../actions/sales-potential.actions';

@Injectable()
export class SalesPotentialEffects {
  private readonly actions$ = inject(Actions);
  private readonly salesPotentialApi = inject(SalesPotentialApiService);
  private readonly store = inject(Store);

  loadSalesPotentials$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(SalesPotentialActionTypes.LoadSalesPotentialsRequest),
      mergeMap((action: LoadSalesPotentialsRequest) =>
        this.salesPotentialApi.getSalesPotentials(action.payload).pipe(
          map((salesPotentials) => new LoadSalesPotentialsSuccess(salesPotentials)),
          startWith(CoreActions.setLoading({ loading: true })),
          finalize(() => this.store.dispatch(CoreActions.setLoading({ loading: false }))),
          catchError((error) => of(new LoadSalesPotentialsFailed(error))),
        ),
      ),
    ),
  );

  deleteSalesPotential$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(SalesPotentialActionTypes.DeleteSalesPotentialRequest),
      mergeMap((action: DeleteSalesPotentialRequest) =>
        this.salesPotentialApi.deleteSalesPotential(action.payload).pipe(
          map(() => new DeleteSalesPotentialSuccess(action.payload)),
          startWith(CoreActions.setLoading({ loading: true })),
          finalize(() => this.store.dispatch(CoreActions.setLoading({ loading: false }))),
          catchError((error) => of(new DeleteSalesPotentialFailed(error))),
        ),
      ),
    ),
  );

  upsertSalesPotential$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(SalesPotentialActionTypes.UpsertSalesPotentialRequest),
      mergeMap((action: UpsertSalesPotentialRequestAction) =>
        this.salesPotentialApi.upsertSalesPotential(action.payload).pipe(
          map((salesPotential) => new UpsertSalesPotentialSuccess(salesPotential)),
          startWith(CoreActions.setLoading({ loading: true })),
          finalize(() => this.store.dispatch(CoreActions.setLoading({ loading: false }))),
          catchError((error) => of(new UpsertSalesPotentialFailed(error))),
        ),
      ),
    ),
  );
}
